import styled from 'styled-components';
import ds from 'designsystem';
import { media } from 'designsystem/index';
import LanguageLink from '../../../elements/LanguageLink';

const StyledLink = styled(LanguageLink)`
  position: relative;
  display: block;
  color: ${ds.brand('text')};
  font-size: ${ds.fontSize('s')};
  font-family: ${ds.get('type.fontFamily.text')};
  font-weight: ${ds.get('type.fontWeight.regular')};
  text-decoration:none;
  padding: ${ds.get('metrics.xs')} 0 ${ds.get('metrics.xs')} 0;

  &.active {
    font-weight: ${ds.get('type.fontWeight.bold')};
  }

  ${media.desktop`
      padding: calc(${ds.get('metrics.xs')} / 2) calc(${ds.get('metrics.xs')} * 2);
  `}
`;

export default StyledLink;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/MainNavigation/StyledLink.jsx